var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b;
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Menu, MenuItem, MenuList, styled } from "@mui/material";
import { useOktaAuth } from "../../hooks/oktaAuth";
import AppBar from "@mui/material/AppBar";
import { Box } from "@mui/system";
import React from "react";
import { useTheme } from "@mui/system";
import Triangle from "./Triangle";
import { useGetClientPlatformQuery, prepareEightfoldDomain, useGetPermissions, useGetDownloadInformation, } from "../../store/api/core";
import SpinnerAndErrorer, { willHold, } from "../SpinnerAndErrorer/SpinnerAndErrorer";
import { hasFeatureFlag, haveLegacyTabs } from "../../common/featureFlags";
import { getRoute } from "../../routes/getAllRoutes";
import styles from "./Header.module.scss";
import { useClient } from "../../hooks/client";
import { TestTag, getAutomationTag } from "../../common/testAutomation";
import { usePermissions } from "../../hooks/permissions";
import { FeatureFlag } from "../../../config/application";
import { PermissionResource } from "../../hooks/permissionTypes";
var adminPortalOrigin = process.env.REACT_APP_ADMIN_PORTAL_URL;
var ACCENT_COLOR = "rgb(24, 118, 140)";
var StyledAppBar = styled(AppBar)(function () { return ({
    "& .MuiList-root": {
        display: "flex",
        justifyContent: "flex-start",
        paddingBottom: "0px",
        width: "auto",
    },
}); });
var StyledMenu = styled(Menu)(function () { return ({
    "& .MuiList-padding": {
        padding: "0",
    },
}); });
var sharedLinkSx = {
    font: "16px/23px var(--font-stack-full-medium)",
    fontWeight: ((_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.includes("cohort-insights"))
        ? 800
        : 500,
    marginRight: "18px",
};
var NavigationItem = function (_a) {
    var onClick = _a.onClick, title = _a.title, bottomSx = _a.bottomSx, sx = _a.sx;
    var theme = useTheme();
    return (_jsx(MenuItem, __assign({ onClick: onClick }, getAutomationTag(TestTag.NavItem, title
        .toLowerCase()
        .replace(/[\s()/]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/-$/, "")), { sx: __assign(__assign(__assign({}, sharedLinkSx), { paddingTop: "20px", height: "25px", paddingBottom: "33px", borderBottom: "3px solid ${theme.palette.primary.light}", color: theme.palette.primary.dark, ":hover": {
                color: ACCENT_COLOR,
                backgroundColor: "inherit",
            } }), (sx !== null && sx !== void 0 ? sx : {})) }, { children: _jsxs("div", __assign({ className: styles.link }, { children: [_jsxs("div", { children: [" ", title, " "] }), _jsx(Box, { sx: __assign({ position: "absolute", bottom: "-8px" }, bottomSx) })] })) })));
};
var NavigationDropdown = function (_a) {
    var title = _a.title, children = _a.children;
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var onMenuClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var closeAccountMenu = function () {
        setAnchorEl(null);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MenuItem, __assign({ onClick: onMenuClick }, getAutomationTag(TestTag.HeaderBtnAccountMenu), { sx: __assign({ paddingLeft: "5px", paddingRight: "5px", cursor: "pointer", ":hover": {
                        backgroundColor: "white",
                    }, position: "relative", bottom: "6px" }, sharedLinkSx) }, { children: [title, _jsx(Box, __assign({ sx: { marginLeft: "10px" } }, { children: _jsx(Triangle, {}) }))] })), _jsx(StyledMenu, __assign({ disableScrollLock: true, keepMounted: false, open: !!anchorEl, anchorEl: anchorEl, onClose: closeAccountMenu, PaperProps: {
                    style: {
                        minWidth: "none",
                        maxWidth: "none",
                        padding: "8px 8px 0",
                        minHeight: "none",
                        maxHeight: "none",
                        boxShadow: "0 1px 2px #0f141f1f, 0 2px 8px #0f141f29;",
                        borderRadius: "16px",
                    },
                } }, { children: children }))] }));
};
var PermissionedNavigationDropdown = function (_a) {
    var title = _a.title, inners = _a.inners;
    return (_jsx(NavigationDropdown, __assign({ title: title }, { children: inners
            .map(function (inner) { return _jsx(NavigationItem, __assign({}, inner), inner.title); })
            .filter(function (component) { return component; }) })));
};
var PermissionedNavigationItem = function (_a) {
    var onClick = _a.onClick, url = _a.url, title = _a.title, permissions = _a.permissions, inners = _a.inners, bottomSx = _a.bottomSx, sx = _a.sx;
    var granteds = usePermissions();
    var handleClick = onClick !== null && onClick !== void 0 ? onClick : (url ? navigateOnClick(url) : undefined);
    return (permissions === null || permissions === void 0 ? void 0 : permissions.some(function (permission) { return granteds[permission]; })) ||
        !permissions ? (inners && inners.length > 0 ? (_jsx(PermissionedNavigationDropdown, { title: title, inners: inners })) : (handleClick && (_jsx(NavigationItem, { onClick: handleClick, sx: sx, title: title, bottomSx: bottomSx })))) : null;
};
var VerticalRule = function () { return _jsx("div", { className: styles.verticalRule }); };
var navigateOnClick = function (url) { return function () {
    window.location.href = url;
}; };
var useNavigationLinks = function () {
    var client = useClient();
    var clientId = client === null || client === void 0 ? void 0 : client.clientId;
    return !clientId
        ? []
        : [
            {
                permissions: [PermissionResource.ASSESSMENTS_PROJECTS],
                title: "Projects",
                onClick: navigateOnClick("".concat(adminPortalOrigin, "/client/").concat(clientId, "/assessments/projects")),
            },
            {
                title: "Cohort Insights",
                onClick: navigateOnClick(getRoute("CohortInsightsV2")),
                bottomSx: {
                    borderBottom: "5px solid ".concat(ACCENT_COLOR),
                    width: "calc(100% - 24px)",
                    height: "5px",
                    borderRadius: "50% 50% 0 0 / 40px 40px 0 0",
                },
                sx: {
                    color: ACCENT_COLOR,
                    ":hover": {
                        backgroundColor: "inherit",
                    },
                },
            },
            {
                permissions: [PermissionResource.ASSESSMENTS_LEADERS],
                title: "Leaders",
                onClick: navigateOnClick("".concat(adminPortalOrigin, "/client/").concat(clientId, "/leaders")),
            },
            {
                permissions: [PermissionResource.SUCCESS_PROFILES],
                title: "Success Profiles",
                onClick: navigateOnClick("".concat(adminPortalOrigin, "/client/").concat(clientId, "/success-profiles")),
                inners: [
                    {
                        permissions: [PermissionResource.SUCCESS_PROFILES_FACTOR_LIBRARY],
                        title: "Factor Library",
                        onClick: navigateOnClick("".concat(adminPortalOrigin, "/client/").concat(clientId, "/success-profiles/factor-library")),
                    },
                    {
                        permissions: [
                            PermissionResource.SUCCESS_PROFILES_VARIABLE_LIBRARY,
                        ],
                        title: "Variable Library",
                        onClick: navigateOnClick("".concat(adminPortalOrigin, "/client/").concat(clientId, "/success-profiles/variable-library/skill-group")),
                    },
                    {
                        permissions: [
                            PermissionResource.SUCCESS_PROFILES_SUCCESS_PROFILE_LIBRARY,
                        ],
                        title: "Success Profile Library",
                        onClick: navigateOnClick("".concat(adminPortalOrigin, "/client/").concat(clientId, "/success-profiles/success-profile-library")),
                    },
                ],
            },
            {
                permissions: [PermissionResource.SETTINGS],
                title: "Settings",
                onClick: navigateOnClick("".concat(adminPortalOrigin, "/client/").concat(clientId, "/settings/company-details")),
            },
        ];
};
var ClientName = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var data = useGetClientPlatformQuery({}).data;
    var companyLogoImage = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.branding) === null || _c === void 0 ? void 0 : _c.find(function (_a) {
        var key = _a.key;
        return key == "COMPANY_LOGO";
    })) === null || _d === void 0 ? void 0 : _d.value;
    var downloadInformation = useGetDownloadInformation({ id: companyLogoImage !== null && companyLogoImage !== void 0 ? companyLogoImage : "" }, { shouldSkipCall: function () { return !companyLogoImage; } }).data;
    var s3Url = (_f = (_e = downloadInformation === null || downloadInformation === void 0 ? void 0 : downloadInformation.data) === null || _e === void 0 ? void 0 : _e.s3_url) !== null && _f !== void 0 ? _f : "";
    if (!s3Url) {
        return (_jsx("div", __assign({ className: styles["adminPortalIntegration"] }, { children: ((_h = (_g = data === null || data === void 0 ? void 0 : data.data) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.name) || "" })));
    }
    return (_jsx("img", __assign({}, getAutomationTag(TestTag.ApplicationLogo), { className: styles["customLogo"], src: s3Url })));
};
var Header = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var clientId = useClient().clientId;
    var location = window.location.pathname;
    var oktaContext = useOktaAuth();
    var permissions = useGetPermissions();
    var platformClients = useGetClientPlatformQuery({});
    var oktaTokenStorage = JSON.parse(localStorage.getItem("okta-token-storage") || "{}");
    var userName = ((_b = (_a = oktaTokenStorage === null || oktaTokenStorage === void 0 ? void 0 : oktaTokenStorage.idToken) === null || _a === void 0 ? void 0 : _a.claims) === null || _b === void 0 ? void 0 : _b.name) || undefined;
    var isClientNavigatorEnabled = (_g = (_f = (_e = (_d = (_c = platformClients === null || platformClients === void 0 ? void 0 : platformClients.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.applications) === null || _f === void 0 ? void 0 : _f.navigator) === null || _g === void 0 ? void 0 : _g.isEnabled;
    var navigationLinks = useNavigationLinks();
    var Logo = function () {
        return hasFeatureFlag(FeatureFlag.AdminPortalIntegrated) &&
            location.includes("cohort-insights") ? (_jsx(ClientName, {})) : location.includes("cohort-insights") ||
            location.includes("success-profiles") ? (_jsx("img", __assign({}, getAutomationTag(TestTag.ApplicationLogo), { className: styles["cohortAndSuccessProfileLogo"], src: getRoute("CohortAndSuccessProfileLogo") }))) : (_jsx("img", __assign({}, getAutomationTag(TestTag.ApplicationLogo), { className: styles["logo"], src: getRoute("Logo") })));
    };
    var Links = function () {
        var _a, _b, _c, _d, _e, _f;
        if (!clientId ||
            !oktaContext.authState ||
            !((_a = oktaContext.authState) === null || _a === void 0 ? void 0 : _a.isAuthenticated)) {
            // If not authenticated, don't try to load navigation
            return _jsx(Box, { sx: { width: "100%" } });
        }
        var eightfoldDomain = prepareEightfoldDomain((_f = (_e = (_d = (_c = (_b = platformClients === null || platformClients === void 0 ? void 0 : platformClients.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.applications) === null || _e === void 0 ? void 0 : _e.navigator) === null || _f === void 0 ? void 0 : _f.url);
        var pathName = window.location.pathname;
        var isCohortInsightsTabActive = pathName.includes("cohort-insights");
        var headerEnabled = haveLegacyTabs();
        var cohortInsightsNavigation = [
            {
                permissions: ["COHORT_INSIGHTS_UI"],
                url: getRoute("CohortInsightsV2"),
                title: "Cohort Insights",
            },
        ];
        var legacyNavigation = [
            {
                permissions: ["ORG_DASHBOARD_UI"],
                url: getRoute("Dashboard"),
                title: "Intelligence",
            },
            {
                url: "".concat(eightfoldDomain, "/careerhub/team-planning/succession"),
                title: "Leader Management",
            },
            {
                permissions: ["SUCCESS_PROFILES_UI"],
                url: getRoute("SuccessProfiles"),
                title: "Success Profiles (beta)",
            },
            {
                permissions: ["ORG_DASHBOARD_UI/REPORTS"],
                url: "".concat(eightfoldDomain, "/talent_management_analytics/dashboard?key=succession_plan_hs_v2"),
                title: "Reports",
            },
            {
                permissions: ["ORG_DASHBOARD_UI/SCENARIO_PLANNING"],
                url: "".concat(eightfoldDomain, "/roles/my-roles?query_id=WNGLpkJnO"),
                title: "Roles",
            },
            {
                permissions: ["ORG_DASHBOARD_UI/USERS"],
                url: "".concat(eightfoldDomain, "/careerhub/search/people"),
                title: "Users",
            },
        ];
        var currentNavigation = [
            {
                permissions: ["ORG_DASHBOARD_UI"],
                url: getRoute("Dashboard"),
                title: "Intelligence",
            },
            {
                permissions: ["ORG_DASHBOARD_UI/LEADERSHIP_MANAGEMENT"],
                url: "".concat(eightfoldDomain, "/careerhub/team-planning/succession"),
                title: "Leadership Management",
            },
            {
                permissions: ["SUCCESS_PROFILES_UI"],
                url: getRoute("SuccessProfiles"),
                title: "Success Profiles (beta)",
            },
            {
                permissions: ["ORG_DASHBOARD_UI/SCENARIO_PLANNING"],
                url: "".concat(eightfoldDomain, "/roles/talent-planning"),
                title: "Scenario Planning (beta)",
            },
            {
                permissions: ["ORG_DASHBOARD_UI/REPORTS"],
                url: "".concat(eightfoldDomain, "/talent_management_analytics/dashboard?key=succession_plan_hs_v2"),
                title: "Reports",
            },
            {
                permissions: [
                    PermissionResource.SUCCESS_PROFILES,
                    "ORG_DASHBOARD_UI/SUCCESS_PROFILES",
                ],
                url: "".concat(eightfoldDomain, "/roles/my-roles"),
                title: "Success Profiles",
            },
            {
                permissions: ["ORG_DASHBOARD_UI/USERS"],
                url: "".concat(eightfoldDomain, "/careerhub/search/people"),
                title: "Users",
            },
        ];
        var mainNavigation = currentNavigation;
        if (hasFeatureFlag(FeatureFlag.AdminPortalIntegrated) &&
            location.includes("cohort-insights")) {
            mainNavigation = navigationLinks;
        }
        else if (isCohortInsightsTabActive) {
            mainNavigation = cohortInsightsNavigation;
        }
        else if (headerEnabled) {
            mainNavigation = legacyNavigation;
        }
        if (willHold([platformClients])) {
            return (_jsx(Box, __assign({ sx: { width: "100%" } }, { children: _jsx(SpinnerAndErrorer, { conditions: [platformClients], errorDescription: "Unable to load navigation.", sx: {
                        position: "unset",
                        alignSelf: "center",
                        marginLeft: "30px",
                    } }) })));
        }
        var ProfileMenuItem = function () { return (_jsx(NavigationItem, __assign({}, getAutomationTag(TestTag.HeaderMenuMyProfile), { onClick: function () {
                window.location.href = "".concat(eightfoldDomain, "/careerhub/profile/");
            }, title: "My Profile" }))); };
        var handleLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, oktaContext.oktaAuth.signOut({})];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return (_jsxs(Box, __assign({ sx: {
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
            } }, { children: [_jsx(MenuList, __assign({ sx: { flexGrow: 1 } }, { children: mainNavigation
                        .map(function (props) { return (_jsx(PermissionedNavigationItem, __assign({}, props), props.title)); })
                        .filter(function (value) { return value; }) })), _jsx(MenuList, __assign({ sx: { marginRight: "20px" } }, { children: _jsxs(NavigationDropdown, __assign({ title: _jsx(UserName, { name: userName }) }, { children: [isClientNavigatorEnabled && !isCohortInsightsTabActive ? (_jsx(ProfileMenuItem, {})) : null, _jsx(NavigationItem, __assign({ title: "Logout", onClick: handleLogout }, getAutomationTag(TestTag.HeaderMenuLogout))), isClientNavigatorEnabled && !isCohortInsightsTabActive ? (_jsx(NavigationItem, __assign({ title: "Settings", onClick: function () {
                                    return (window.location.href = "".concat(eightfoldDomain, "/careerhub/settings"));
                                } }, getAutomationTag(TestTag.HeaderMenuSettings)))) : null] })) }))] })));
    };
    var StyledLinks = styled(Links)({});
    var UserName = function (_a) {
        var _b, _c, _d, _e;
        var name = _a.name;
        var width = "40px";
        var words = (name === null || name === void 0 ? void 0 : name.split(/\s+/g)) || [];
        var firstLetter = (_c = (_b = words[0]) === null || _b === void 0 ? void 0 : _b.slice(0, 1)) === null || _c === void 0 ? void 0 : _c.toUpperCase();
        var lastLetter = (_e = (_d = words[words.length - 1]) === null || _d === void 0 ? void 0 : _d.slice(0, 1)) === null || _e === void 0 ? void 0 : _e.toUpperCase();
        if (!firstLetter) {
            return null;
        }
        var Letters = function () {
            return (_jsx(Box, __assign({ component: "span", sx: {
                    width: width,
                    color: "white",
                    display: "inline-flex",
                    justifyContent: "center",
                    position: "relative",
                    top: "2px",
                } }, { children: _jsx(Box, __assign({ component: "span" }, { children: words.length > 1 ? "".concat(firstLetter).concat(lastLetter) : firstLetter })) })));
        };
        return (_jsx(Box, __assign({ sx: {
                height: width,
                width: width,
                backgroundColor: "rgb(105, 113, 127)",
                borderRadius: "50%",
                display: "inline-flex",
                flexDirection: "column",
                justifyContent: "center",
            } }, { children: _jsx(Letters, {}) })));
    };
    var LoaderContainer = styled(Box)({
        position: "fixed",
        display: "flex",
        flexDirection: "row",
        left: "calc(50% - 150px)",
        top: "50%",
    });
    if (!permissions) {
        return (_jsxs(LoaderContainer, { children: [" ", _jsx(SpinnerAndErrorer, { conditions: { spin: function () { return false; }, error: function () { return false; } } }), " "] }));
    }
    if (permissions && (permissions === null || permissions === void 0 ? void 0 : permissions.length) > 0) {
        return (_jsxs(Box, __assign({ className: styles.headerContainer, "data-testid": "Header" }, getAutomationTag(TestTag.HeaderContainer), { children: [_jsx(Box, { className: styles.headerBackground }), _jsx(StyledAppBar, __assign({ className: styles.tabBar }, getAutomationTag(TestTag.HeaderAppBar), { children: _jsxs(Box, __assign({ className: styles.logoContainer }, { children: [_jsx(Logo, {}), _jsx(VerticalRule, {}), _jsx(StyledLinks, {})] })) }))] })));
    }
    else {
        if (!location.includes(getRoute("PermissionsNotFound"))) {
            window.location.href = getRoute("PermissionsNotFound");
        }
    }
};
export default Header;
